import { DASHBOARD_PREFERENCES_VERSION } from './constants';
import { DEFAULT_DASHBOARD_PREFERENCES, type DashboardPreferences } from './types';

const isDashboardPreferences = (value: unknown): value is DashboardPreferences => {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const candidate = value as Partial<DashboardPreferences>;
  return Array.isArray(candidate.hiddenCards) && candidate.hiddenCards.every((item) => typeof item === 'string');
};

const normalizePreferences = (value: DashboardPreferences): DashboardPreferences => {
  const deduped = Array.from(new Set(value.hiddenCards));
  return {
    hiddenCards: deduped,
    version: typeof value.version === 'number' ? value.version : DASHBOARD_PREFERENCES_VERSION,
    updatedAt: value.updatedAt,
  };
};

export const buildDashboardPreferencesStorageKey = (userId: string) =>
  `dashboard_preferences_v${DASHBOARD_PREFERENCES_VERSION}_${userId}`;

export const readDashboardPreferencesFromStorage = (userId: string): DashboardPreferences => {
  try {
    const raw = localStorage.getItem(buildDashboardPreferencesStorageKey(userId));
    if (!raw) return DEFAULT_DASHBOARD_PREFERENCES;
    const parsed = JSON.parse(raw) as unknown;
    if (!isDashboardPreferences(parsed)) return DEFAULT_DASHBOARD_PREFERENCES;
    return normalizePreferences(parsed);
  } catch {
    return DEFAULT_DASHBOARD_PREFERENCES;
  }
};

export const writeDashboardPreferencesToStorage = (userId: string, value: DashboardPreferences) => {
  const normalized: DashboardPreferences = {
    ...normalizePreferences(value),
    updatedAt: value.updatedAt ?? new Date().toISOString(),
  };
  localStorage.setItem(buildDashboardPreferencesStorageKey(userId), JSON.stringify(normalized));
};
